import { ChevronDownIcon, ChevronRightIcon } from '@radix-ui/react-icons'
import { FC, useState } from 'react'
import styled from 'styled-components'

const StyledChevronIcon = styled.div`
  color: lightgray;
  cursor: pointer;
  display: flex;
  align-items: center;
  &:hover {
    color: white;
  }
`

type CollapseButtonProp = {
  handleCollapse?: (collapsed: boolean) => void
}

export const CollapseButton: FC<CollapseButtonProp> = ({ handleCollapse }) => {
  const [isCollapsed, setIsCollapsed] = useState(false)

  const toggleCollapse = (e: React.MouseEvent) => {
    e.stopPropagation()
    setIsCollapsed(!isCollapsed)

    if (handleCollapse) handleCollapse(!isCollapsed)
  }

  return (
    <StyledChevronIcon onClick={(e) => toggleCollapse(e)}>
      {!isCollapsed ? (
        <ChevronDownIcon width={18} height={18} />
      ) : (
        <ChevronRightIcon width={18} height={18} />
      )}
    </StyledChevronIcon>
  )
}
